import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import EngagementStats from '../components/EngagementStats';
import FloatingBadges from '../components/FloatingBadges';
import Footer from '../components/Footer';
import './ModelPage.css';
import '../styles/model-profile.css';
import '../styles/custom-model-overrides.css';
import { useLang } from '../contexts/LanguageContext';
import { getTgBotUserBongo } from '../services/firestore';
import { useRegisterModal } from '../contexts/RegisterModalContext';
import blondeVideo from '../videos/Blondevideo.mp4';
import brunetteVideo from '../videos/Brunnetevideo.mp4';
import redheadVideo from '../videos/Redheadvideo.mp4';

const VIDEO_MAP = {
  'Светлая': blondeVideo,
  'Темная': brunetteVideo,
  'Рыжая': redheadVideo,
};

// Генерация случайных ников
const NICKNAMES = [
  'lovely_girl', 'bigspender', 'big_heart', 'sweet_dreams', 'generous_guy',
  'lucky_star', 'fun_guy', 'happy_viewer', 'fun_time', 'starlight',
  'cool_cat', 'dreamer', 'night_owl', 'sunshine', 'mystery_man',
  'angel_eyes', 'wild_card', 'golden_boy', 'silver_fox', 'diamond_king',
  'rose_petal', 'moon_child', 'fire_fly', 'ocean_wave', 'sky_walker'
];

const CHAT_MESSAGES = [
  'Ну что, готова к небольшому флирту? Обещаю — будет интересно 😏',
  'Твой взгляд уже успел поджечь воображение… Как ты так умеешь?',
  'Если бы у меня было волшебство, я бы превратил этот чат в наше секретное место.',
  'Ты такая загадка… хочется разгадывать тебя всю ночь 🌙',
  'Представь, что я уже рядом и шепчу тебе что-то на ухо… Что бы ты захотела услышать?',
  'Кажется, мы только начали разговор, а я уже жажду твоих тайн.',
  'У тебя такой голос в мыслях, что может свести с ума… Представляешь, если услышать его наяву?',
  'Ты ведь знаешь, как легко свести с ума одним словом? Попробуй — я готов к вызову.',
  'Мне интересно, какой запрос ты давно хотела услышать, но никто не решался сказать?',
  'Скажи, какая мечта у тебя самая запретная? Или хотя бы самая возбуждающая?',
  'Не могу перестать думать, что мы идеально подошли бы друг другу для весёлой игры без правил.',
  'Когда ты улыбаешься, мир становится чуть ярче — даже через экран телефона.',
  'Ты умеешь держать интригу? Потому что я собираюсь её раскрывать по частям 😉',
  'Если бы я сказал, что хочу увидеть твою улыбку прямо сейчас — это слишком смело?',
  'Вот незадача — я всё время ловлю себя на мысли о твоём взгляде.',
  'Расскажи, от чего загорается твой внутренний огонь? Мне это очень интересно…',
  'Давай сделаем так: ты задаёшь вопрос, а я отвечаю честно и без фильтров.',
  'Я тут подумал — с тобой точно не соскучишься, что готов поспорить? 😉',
  'Хочешь я расскажу, что происходит в моей голове, когда вижу твоё имя в чате?',
  'Кажется, этот разговор только начинается, а меня уже накрывает волной эмоций…',
  'Ты веришь в искры между людьми? Мне кажется, у нас есть шансы устроить фейерверк.',
  'Люблю, когда общение заходит за рамки обычного — давай попробуем?',
  'Если бы слова могли обжигать, я был бы уже в огне от твоих сообщений.',
  'Если я сяду рядом, скажи, что ты скажешь первой?',
  'Ты умеешь сохранять тайну? Потому что я собираюсь рассказать нечто особенное.',
  'Когда ты улыбаешься, у меня создаётся ощущение, что весь мир затаил дыхание.',
  'Ты умеешь играть словами так, чтобы они возбуждали воображение? Покажи!',
  'Как думаешь, кто из нас дуэль выигрывает — словом или взглядом?',
  'Расскажи про самый озорной момент на этой неделе!',
  'Если бы я сказал, что хочу превратить этот чат в маленькое приключение, ты согласна?',
  'Ты умеешь читать между строк? Потому что я пишу не просто так…',
  'Может, расскажешь, о чём мечтаешь, когда никого вокруг нет?',
  'Понимаешь, я уже начинаю фантазировать, что мы договоримся встретиться в каком-то кафе на углу…',
  'Не хочешь немного подогреть эту беседу тайными вопросами?',
  'Если сейчас открыть окно и позвать меня, ты это сделаешь?',
  'Что заставляет твои глаза сиять — кроме твоей улыбки, разумеется?',
  'Ты когда-нибудь думала о неожиданном повороте в реальной жизни? Что бы это было?',
  'Может быть, мы придумали бы своё маленькое кодовое слово для нашей тайны?',
  'Ты такая загадочная, что я уже по уши увяз в твоих словах.',
  'Как думаешь, у нас хватит смелости заговорить обо всём, что обычно скрываем?',
  'Если бы наши мысли могли встретиться, что бы они друг другу сказали?',
  'Ты знаешь, как пробуждать интерес одним лишь намёком? Я учусь у тебя.',
  'Мне нравится твой стиль общения — он такой искренний и немного дерзкий.',
  'Хотел спросить, но боюсь — вдруг ты уже придумала ответ и ждёшь моего хода?',
  'Если бы флирт был спортом, я бы уже выиграл золотую медаль с тобой в паре.',
  'Какие слова у тебя вызывают улыбку? Может, я угадаю?',
  'Ты когда-нибудь ощущала, что связь между собеседниками сильнее, чем экран между ними?',
  'Расскажи, что тебя может вывести из себя… но только в хорошем смысле.',
  'Если бы я предложил загадать желание, ты бы поверила, что оно сбудется?',
  'Ты умеешь слушать сердцем? Мне кажется, у меня есть что-то важное сказать.',
  'Что бы ты хотела делать прямо сейчас, если бы у нас была возможность?',
  'Ты предпочитаешь говорить о своих желаниях или их только намекать?',
  'Если бы какой-то момент из этого чата мог бы стать вечным, какой бы это был?',
  'Твой голос – одна из тех вещей, которые хочется записать и слушать вечно.',
  'Ты умеешь выбирать слова так, чтобы они только подогревали интерес? Покажи пример!',
  'Если бы я был художником, то нарисовал бы тебя мечтой в каждом штрихе.',
  'Ты когда-нибудь мечтала о приключении, которое начинается с одного сообщения?',
  'Что ты делаешь, когда хочется шалить, но нет рядом того, кто позволит?',
  'Ты знаешь, как сделать так, чтобы сердце билось быстрее, даже не касаясь меня?',
  'Если бы у нас была музыкальная тема, как бы она звучала? Предлагаю сыграть вместе.',
  'Ты предпочитаешь быть загадкой или откровенностью? Или чуть-чуть тем и другим?',
  'Какой вопрос ты бы задала, если бы могла узнать обо мне всё?',
  'Ты любишь сюрпризы? Я уверен, что могу придумать несколько интересных…',
  'Что лучше — тёплый вечер с приятным разговором или ночь, полная огня и страсти?',
  'Если бы однажды мы встретились, что бы ты загадала спросить сначала?',
  'Ты предпочитаешь долгие беседы или яркие моменты, оставляющие вкусовое послевкусие?',
  'Ты умеешь шутить так, чтобы я не мог остановиться от смеха и улыбки одновременно?',
  'Расскажи, какой комплимент тебя заводит больше всего — я подготовлю свой!',
  'Ты когда-нибудь чувствовала, что разговор с человеком меняет настроение мгновенно?',
  'Если бы я предложил нам сыграть в игру: «Правда или желание», ты согласилась бы?',
  'Может быть, ты любишь секреты, которые можно шептать только на ушко?',
  'Твой взгляд такой магнетический — можно попросить секретный рецепт?',
  'Если бы всё время, что мы общаемся, превратить в минуты, сколько бы уже прошло?',
  'Какой вопрос тебя бы завёл в разговоре больше всего? Я готов слушать!',
  'Ты веришь, что иногда достаточно пары слов, чтобы завести искру между людьми?',
  'Если бы можно было выделить самый яркий момент нашего общения, что бы это было?',
  'Ты умеешь поднимать настроение одним лишь сообщением? Проверь, как это работает!',
  'Пусть этот чат станет нашей маленькой тайной, которую никто не раскроет.',
  'Расскажи, что для тебя самое важное в общении с незнакомцем?',
  'Ты ведь знаешь, что иногда плохие игры — самые запоминающиеся? Готова рискнуть?',
  'Если бы я рассказал тебе секрет, поверишь ли, что он только для тебя?',
  'Что ты делаешь, когда хочешь быть смелой, но немного стесняешься?',
  'Ты когда-нибудь говорила что-то настолько дерзкое, что сама удивлялась потом?',
  'Если бы это был наш маленький приватный мир, что бы ты хотела, чтобы я сказал первым?',
  'Ты умеешь создавать атмосферу одним лишь текстом? Попробуй меня заворожить.',
  'Расскажи, что для тебя значит флирт? Давай сравним определения.',
  'Ты когда-нибудь чувствовала, что искренность в словах — это самое сексуальное?',
  'Как думаешь, какие слова могут завести так, чтобы не было пути назад?',
  'Если бы у тебя была возможность назначить нам вечеринку, какой была бы её тема?',
  'Какой комплимент тебе нравится больше всего: о внешности или о характере?',
  'Ты любишь, когда общение внезапно становится очень личным и насыщенным?',
  'Если бы я предложил сыграть противостояние взглядов, кто выиграл бы, ты или я?',
  'Ты предпочитаешь лёгкость в флирте или мощный эмоциональный заряд?',
  'Если бы мы писали книгу нашего знакомства, как бы звучало первое предложение?',
  'Ты когда-нибудь ощущала, что слова на экране могут звучать намного громче, чем вживую?',
  'Может, расскажешь, какую роль играет игривость в твоём дне?',
  'Ты когда-нибудь ловила себя на мысли, что интернет открыл новую грань флирта?',
  'Как думаешь, что важнее: слова, действия или искренность?',
  'Если бы наша переписка была песней — какой жанр ей бы подошёл?',
  'Что бы ты сделала, если бы я неожиданно пригласил тебя на каву в свой город?',
  'Ты умеешь смеяться так заразительно, что даже через текст чувствуешь настроение?',
  'Если бы у нас была возможность просто помолчать, чувствуя присутствие друг друга — ты бы хотела?',
  'Расскажи, что в твоём понимании идеальный флирт? Чтобы точно запомнился надолго.',
  'Ты мечтала когда-нибудь, чтобы простой чат превратился в нечто большее?',
  'Если бы я предложил нам испытать судьбу — согласилась бы без колебаний?',
  'Ты умеешь хранить интригу так долго, что человек сгорает от любопытства?',
  'Какой самый милый комплимент ты получала сегодня, а какой ждёшь?',
  'Ты чувствуешь, когда слова переходят в эмоции? Мне кажется, наш момент уже близок.',
];

const TOKEN_AMOUNTS = [5, 10, 15, 20, 25, 50, 100];

const MODELS_DATA = {
  'margo00': {
    name: 'Margo00',
    age: 37,
    height: 170,
    hairColor: 'Brunette',
    // new profile fields
    weight: '60 кг',
    bust: '3-й',
    bodyType: 'Athletic',
    avatar: null,
  },
  'anna_sweet': {
    name: 'Anna_Sweet',
    age: 24,
    height: 165,
    hairColor: 'Blonde',
    weight: '54 кг',
    bust: '2-й',
    bodyType: 'Slim',
    avatar: null,
  },
  'kate_moon': {
    name: 'Kate_Moon',
    age: 29,
    height: 172,
    hairColor: 'Red',
    weight: '62 кг',
    bust: '3-й',
    bodyType: 'Curvy',
    avatar: null,
  },
};

function getRandomItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function generateChatEvent() {
  // редкая подписка, затем донат, иначе текст
  const isSubscribe = Math.random() < 0.22; // ~22% шанс
  const isToken = !isSubscribe && Math.random() > 0.35;
  const nick = getRandomItem(NICKNAMES);
  if (isSubscribe) {
    const verb = Math.random() > 0.5 ? 'подписался' : 'подписалась';
    return {
      type: 'subscribe',
      nick,
      content: `${nick} ${verb} на подписку! Добро пожаловать!`,
      time: new Date(),
    };
  }
  if (isToken) {
    const amount = getRandomItem(TOKEN_AMOUNTS);
    const genderEnd = Math.random() > 0.5 ? 'подарил' : 'подарила';
    // token message with structured fields
    return {
      type: 'token',
      nick,
      amount,
      verb: genderEnd,
      content: `${genderEnd} ${amount} токенов!`,
      time: new Date(),
    };
  }

  // text message: sometimes short, sometimes long
  const text = getRandomItem(CHAT_MESSAGES);
  return {
    type: 'message',
    nick,
    content: text,
    time: new Date(),
  };
}

function ModelPage() {
  const { id } = useParams();
  const [chatMessages, setChatMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isPrivateMode, setIsPrivateMode] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [viewerCount] = useState(Math.floor(Math.random() * 500) + 100);
  const [showPrivateModal, setShowPrivateModal] = useState(false);
  const [camControlActive, setCamControlActive] = useState(null);
  const [privateMessages, setPrivateMessages] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const { lang, setLang, t } = useLang();
  const [showLangMenu, setShowLangMenu] = useState(false);
  const [modelSearch, setModelSearch] = useState('');
  const [sortByTokens, setSortByTokens] = useState(false);
  const [mobileTab, setMobileTab] = useState('video'); // 'video' | 'chat' | 'profile'

  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const videoRef = useRef(null);

  const { openRegister } = useRegisterModal();

  // Firebase: загрузка данных из tg-bot-users-bongo по id из URL
  const [bongoData, setBongoData] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [pageError, setPageError] = useState(null);

  useEffect(() => {
    if (!id) { setPageLoading(false); setNotFound(true); return; }
    setPageLoading(true);
    setNotFound(false);
    setPageError(null);
    getTgBotUserBongo(id)
      .then((data) => {
        if (data) { setBongoData(data); }
        else { setNotFound(true); }
      })
      .catch((err) => {
        console.error('[ModelPage] fetch error:', err);
        if (err?.code === 'permission-denied') {
          setPageError('permission-denied');
        } else {
          setNotFound(true);
        }
      })
      .finally(() => setPageLoading(false));
  }, [id]);

  const bongo = bongoData?.data?.bongo || {};
  const videoSrc = VIDEO_MAP[bongo.video_girl] || brunetteVideo;
  const model = {
    name: bongo.name || id || 'Unknown',
    age: bongo.age || 25,
    height: 168,
    hairColor: bongo.video_girl || 'Brown',
    weight: '58 кг',
    bust: bongo.chest ? `${bongo.chest}-й` : '2-й',
    butt: bongo.buttocks || 'Средняя',
    bodyType: 'Slim',
    avatar: bongo.photo || null,
  };

  // Show Private Modal after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPrivateModal(true);
    }, 8000); // 8 seconds delay
    return () => clearTimeout(timer);
  }, []);

  // Convert modal trigger into a bottom-left toast message
  useEffect(() => {
    if (!showPrivateModal) return;
    const id = Date.now() + Math.random();
    const msg = {
      id,
      title: t('privateAccessShort'),
      body: t('privateAccessBody', model.name),
      time: new Date(),
    };
    setPrivateMessages(prev => [...prev, msg]);
    // close modal flag (we use toasts now)
    setShowPrivateModal(false);
    // auto-remove after 12s
    const timer = setTimeout(() => {
      setPrivateMessages(prev => prev.filter(m => m.id !== id));
    }, 12000);
    return () => clearTimeout(timer);
  }, [showPrivateModal, model.name, t]);

  // Генерация начальных сообщений
  useEffect(() => {
    const initial = Array.from({ length: 12 }, (_, i) => ({
      id: i,
      ...generateChatEvent(),
    }));
    setChatMessages(initial);
  }, []);

  // Авто-генерация новых сообщений (реже и с контролем таймаутов)
  useEffect(() => {
    let mounted = true;
    let timeoutId;
    const scheduleNext = () => {
      // Задержка между сообщениями 3000-6000ms для уменьшения частоты
      const delay = Math.random() * 3000 + 3000;
      timeoutId = setTimeout(() => {
        if (!mounted) return;
        setChatMessages(prev => {
          const newMsg = {
            id: Date.now() + Math.random(),
            ...generateChatEvent(),
          };
          const updated = [...prev, newMsg];
          return updated.slice(-50); // Максимум 50 сообщений
        });
        scheduleNext();
      }, delay);
    };
    scheduleNext();
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, []);

  // Автоскролл чата
  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;
    try {
      // Если пользователь не листал сильно вверх — плавно докручиваем контейнер
      const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      const shouldAutoScroll = distanceFromBottom < 200; // если пользователь близко к низу
      if (shouldAutoScroll) {
        container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
      }
    } catch (e) {
      // fallback: классический scrollTop
      container.scrollTop = container.scrollHeight;
    }
  }, [chatMessages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;
    
    const newMsg = {
      id: Date.now(),
      type: 'message',
      nick: 'Вы',
      content: inputMessage,
      isOwn: true,
      time: new Date(),
    };
    setChatMessages(prev => [...prev, newMsg]);
    setInputMessage('');
  };

  if (pageLoading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#0d0f1a', color: '#fff',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '44px', height: '44px',
            border: '3px solid rgba(255,255,255,0.15)',
            borderTopColor: '#667eea',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 16px',
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px' }}>Загрузка...</p>
        </div>
      </div>
    );
  }

  if (notFound || pageError) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#0d0f1a', color: '#fff',
        padding: '24px', textAlign: 'center',
      }}>
        <div>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>
            {pageError === 'permission-denied' ? '🔒' : '🔍'}
          </div>
          <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '12px' }}>
            {pageError === 'permission-denied' ? 'Нет доступа' : 'Страница не найдена'}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '15px', maxWidth: '360px', margin: '0 auto' }}>
            {pageError === 'permission-denied'
              ? 'Правила Firestore запрещают чтение коллекции tg-bot-users-bongo. Откройте Firebase Console → Firestore → Rules и добавьте разрешение на чтение.'
              : <>Страница <strong style={{ color: 'rgba(255,255,255,0.8)' }}>/{id}</strong> не существует или была удалена.</>
            }
          </p>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      className={`model-page mobile-active-${mobileTab}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* HEADER */}
      <motion.header
        className="site-header"
        initial={{ y: -60 }}
        animate={{ y: 0 }}
        transition={{ type: 'spring', stiffness: 120, damping: 20 }}
      >
        <div className="header-left">
          <span className="header-icon">≋</span>
          <span className="header-title">{t('siteTitle')}</span>
        </div>
        <div className="header-right">
          {/* viewer badge removed as requested */}

          <div className="header-token-search">
            <div className="header-token">
              <span className="token-count">0</span>
              <span className="token-label">{t('tokenLabel')}</span>
            </div>
            <button className={`header-sort ${sortByTokens ? 'active' : ''}`} onClick={() => openRegister(t('modalTokensMsg'))}>
              {t('byToken')}
            </button>
            <form className="header-search" onSubmit={(e) => { e.preventDefault(); /* implement search */ }}>
              <input value={modelSearch} onChange={(e)=>setModelSearch(e.target.value)} placeholder={t('searchModelPlaceholder')} />
            </form>
          </div>

          <div className="header-actions">
            <div className="lang-selector">
              {/* simple inline SVG flags mapping */}
              {/** raw svg icons kept small and lightweight **/}
              {/** eslint-disable-next-line react-hooks/rules-of-hooks -- static mapping in render **/}
              <>
                {/** Flag SVGs mapping */}
                {null}
              </>
              <button className="lang-btn" onClick={() => setShowLangMenu(!showLangMenu)}>
                <span className="flag-icon">
                  {(
                    {
                      RU: (
                        <svg width="20" height="14" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
                          <rect width="20" height="4.666" y="0" fill="#fff" />
                          <rect width="20" height="4.666" y="4.666" fill="#0039A6" />
                          <rect width="20" height="4.666" y="9.332" fill="#D52B1E" />
                        </svg>
                      ),
                      EN: (
                        <svg width="20" height="14" viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">
                          <rect width="60" height="30" fill="#012169"/>
                          <path d="M0 0 L60 30 M60 0 L0 30" stroke="#fff" strokeWidth="6"/>
                          <path d="M0 0 L60 30 M60 0 L0 30" stroke="#C8102E" strokeWidth="3"/>
                          <rect x="25" width="10" height="30" fill="#fff"/>
                          <rect y="10" width="60" height="10" fill="#fff"/>
                          <rect x="27" width="6" height="30" fill="#C8102E"/>
                          <rect y="12" width="60" height="6" fill="#C8102E"/>
                        </svg>
                      ),
                      ES: (
                        <svg width="20" height="14" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
                          <rect width="20" height="14" fill="#C60B1E"/>
                          <rect y="4" width="20" height="6" fill="#FFC400"/>
                        </svg>
                      ),
                      FR: (
                        <svg width="20" height="14" viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg">
                          <rect width="5" height="10" fill="#0055A4"/>
                          <rect x="5" width="5" height="10" fill="#fff"/>
                          <rect x="10" width="5" height="10" fill="#EF4135"/>
                        </svg>
                      ),
                      DE: (
                        <svg width="20" height="14" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
                          <rect width="20" height="4.666" y="0" fill="#000" />
                          <rect width="20" height="4.666" y="4.666" fill="#DD0000" />
                          <rect width="20" height="4.666" y="9.332" fill="#FFCE00" />
                        </svg>
                      ),
                    }[lang] || (
                      <svg width="20" height="14" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
                        <rect width="20" height="14" fill="#888" />
                      </svg>
                    )
                  )}
                </span>
                <span style={{ marginLeft: 6 }}>{lang} ▾</span>
              </button>
              <AnimatePresence>
                {showLangMenu && (
                  <motion.div className="lang-menu" initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -6 }}>
                    {['RU','EN','ES','FR','DE'].map(l => (
                      <div key={l} className={`lang-item ${lang===l? 'active':''}`} onClick={() => { setLang(l); setShowLangMenu(false); }}>
                        <span className="flag-item">
                          {(
                            {
                              RU: (<svg width="18" height="12" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="4.666" y="0" fill="#fff" /><rect width="20" height="4.666" y="4.666" fill="#0039A6" /><rect width="20" height="4.666" y="9.332" fill="#D52B1E" /></svg>),
                              EN: (<svg width="18" height="12" viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="30" fill="#012169"/><path d="M0 0 L60 30 M60 0 L0 30" stroke="#fff" strokeWidth="6"/><path d="M0 0 L60 30 M60 0 L0 30" stroke="#C8102E" strokeWidth="3"/><rect x="25" width="10" height="30" fill="#fff"/><rect y="10" width="60" height="10" fill="#fff"/><rect x="27" width="6" height="30" fill="#C8102E"/><rect y="12" width="60" height="6" fill="#C8102E"/></svg>),
                              ES: (<svg width="18" height="12" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="14" fill="#C60B1E"/><rect y="4" width="20" height="6" fill="#FFC400"/></svg>),
                              FR: (<svg width="18" height="12" viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg"><rect width="5" height="10" fill="#0055A4"/><rect x="5" width="5" height="10" fill="#fff"/><rect x="10" width="5" height="10" fill="#EF4135"/></svg>),
                              DE: (<svg width="18" height="12" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="4.666" y="0" fill="#000" /><rect width="20" height="4.666" y="4.666" fill="#DD0000" /><rect width="20" height="4.666" y="9.332" fill="#FFCE00" /></svg>),
                            }[l] || (<svg width="18" height="12" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="14" fill="#888" /></svg>)
                          )}
                        </span>
                        <span style={{ marginLeft: 8 }}>{l}</span>
                      </div>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {!isLoggedIn ? (
              <div className="auth-buttons">
                <button className="auth-btn login" onClick={() => openRegister('Войдите через Telegram для полного доступа')}>{t('login')}</button>
                <button className="auth-btn signup" onClick={() => openRegister('Зарегистрируйтесь через Telegram')}>{t('signup')}</button>
              </div>
            ) : (
              <div className="profile-wrap">
                <div className="profile-icon" onClick={() => setShowProfileMenu(!showProfileMenu)}>{/* initials */}
                  <span>{/* initials from model or user */}U</span>
                </div>
                <AnimatePresence>
                  {showProfileMenu && (
                    <motion.div className="profile-menu" initial={{ opacity:0, y:-6 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, y:-6 }}>
                      <div className="pm-item">{t('profile')}</div>
                      <div className="pm-item">{t('settings')}</div>
                      <div className="pm-item" onClick={() => { setIsLoggedIn(false); setShowProfileMenu(false); }}>{t('logout')}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}
          </div>
        </div>
      </motion.header>

      {/* (ENGAGEMENT STATS MOVED) - will render under video for better UX */}

      {/* MODEL TOP BAR (profile header) */}
      <div className="model-topbar user-mt-lg user-mb-lg">
        <div className="model-topbar-left">
          <div className="model-avatar-small">
            {model.avatar
              ? <img src={model.avatar} alt={model.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }} />
              : <div className="avatar-initial-small">{(model.name||'fff').charAt(0).toUpperCase()}</div>
            }
            <div className="live-pill">LIVE</div>
          </div>
          <div className="model-meta">
            <div className="model-name-row">
              <span className="model-name">{model.name || 'fff'}</span>
              <span className="model-gender" title="gender">♀</span>
              <div className="small-badges">
                <span className="badge fanboost">FAN BOOST</span>
                <span className="badge help">?</span>
              </div>
            </div>
            <div className="model-subrow">{t('bodyTypeSlim')} • {model.age || 25} {t('yrs')}</div>
          </div>
        </div>

        <div className="model-topbar-actions">
          <button className="action-btn" onClick={() => openRegister(t('modalFollowMsg'))}><span className="icon">⭐</span><span> {t('follow')}</span></button>
          <button className="action-btn" onClick={() => openRegister(t('modalFollowMsg'))}><span className="icon">📌</span><span> {t('pinModel')}</span></button>
          <button className="action-btn" onClick={() => openRegister(t('modalFollowMsg'))}><span className="icon">🔔</span><span> {t('notifyWhenOnline')}</span></button>
          <button className="action-btn" onClick={() => openRegister(t('modalChatMsg'))}><span className="icon">✉️</span><span> {t('privateMessage')}</span></button>
          <button className="action-btn send-tip" onClick={() => openRegister(t('modalTokensMsg'))}><span className="icon">＋</span><span> {t('tip')}</span></button>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="main-content">
        {/* LEFT - VIDEO */}
        <motion.div
          className="video-section mobile-section"
          data-mobile="video"
          initial={{ x: -40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="video-container">
            <div className="video-placeholder">
              {/* ACTUAL VIDEO */}
              <video
                ref={videoRef}
                src={videoSrc}
                className="bg-video"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                style={{
                  position: 'absolute', inset: 0,
                  width: '100%', height: '100%',
                  objectFit: 'cover',
                  opacity: 1,
                  transition: 'opacity 0.4s ease',
                }}
              />
              <div className="video-gradient" style={{ opacity: showOverlay ? 0.45 : 0.18, transition: 'opacity 0.4s' }} />
              
              <AnimatePresence>
                {showOverlay && (
                  <motion.div
                    className="video-overlay"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.3 }}
                  >
                    <motion.button
                      className="play-btn"
                      onClick={() => openRegister(t('play'))}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {t('play')}
                    </motion.button>
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.div
                className="video-live-indicator"
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <span className="live-badge">● LIVE <span className="quality-badge">4K ULTRA</span></span>
              </motion.div>
              
              {/* CAM CONTROLS (FAKE) */}
              {!showOverlay && (
                <div className="cam-controls-overlay">
                  {['ZOOM', 'FOCUS', 'ANGLE', 'LIGHT'].map((ctrl) => (
                    <motion.button
                      key={ctrl}
                      className={`cam-ctrl-btn ${camControlActive === ctrl ? 'active' : ''}`}
                      onClick={() => openRegister(t('modalVipMsg'))}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      {ctrl}
                    </motion.button>
                  ))}
                  {camControlActive && (
                    <motion.div 
                      className="cam-status-toast"
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                    >
                      <span className="scramble-text">ACCESSING {camControlActive}... [LOCKED]</span>
                      <small>Upgrade to VIP for control</small>
                    </motion.div>
                  )}
                </div>
              )}

                  {/* PRIVATE ACCESS TOASTS (bottom-left) */}
                  <div className="private-toasts">
                    <AnimatePresence>
                      {privateMessages.map((msg) => (
                        <motion.div
                          key={msg.id}
                          className="private-toast"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.28 }}
                          layout
                        >
                          <div className="toast-top">
                            <span className="toast-title">{msg.title}</span>
                            <span className="toast-time">{new Date(msg.time).toLocaleTimeString()}</span>
                          </div>
                          <div className="toast-body">{msg.body}</div>
                          <div className="toast-actions">
                            <button className="toast-close" onClick={() => openRegister(t('close'))}>{t('close')}</button>
                          </div>
                        </motion.div>
                      ))}
                    </AnimatePresence>
                  </div>

                  {/* FLOATING BADGES OVER VIDEO */}
                  <FloatingBadges />

                  
            </div>

            {/* ACTION BUTTONS */}
            <div className="action-buttons-grid">
              <motion.button
                className="action-card group-chat"
                whileHover={{ y: -4, boxShadow: "0 10px 20px rgba(0,0,0,0.4)" }}
                onClick={() => openRegister(t('modalChatMsg'))}
              >
                <span className="card-icon">💬</span>
                <span className="card-label">{t('publicChat')}</span>
                <span className="card-sub">{t('freeAccess')}</span>
              </motion.button>
              
              <motion.button
                className="action-card private-chat glow-gold"
                whileHover={{ y: -4, boxShadow: "0 0 25px rgba(255, 215, 0, 0.4)" }}
                onClick={() => openRegister(t('modalPrivateMsg'))}
              >
                <span className="card-icon">🔒</span>
                <span className="card-label">{t('privateShow')}</span>
                <span className="card-sub">{t('requestAccess')}</span>
              </motion.button>
              
              <motion.button
                className="action-card send-tokens"
                whileHover={{ y: -4, boxShadow: "0 10px 20px rgba(40, 200, 60, 0.2)" }}
                onClick={() => openRegister(t('modalTokensMsg'))}
              >
                <span className="card-icon">💎</span>
                <span className="card-label">{t('sendTokens')}</span>
                <span className="card-sub">{t('supportModel')}</span>
              </motion.button>
              
              <motion.button
                className="action-card vip-club"
                whileHover={{ scale: 1.02 }}
                onClick={() => openRegister(t('modalVipMsg'))}
              >
                 <span className="card-icon">👑</span>
                  <span className="card-label">{t('vipClub')}</span>
              </motion.button>
            </div>
          </div>
          {/* PROFILE SECTION */}
          {/* ENGAGEMENT STATS (under video) */}
          <EngagementStats className="under-video-stats" />

          {/* PROFILE SECTION */}
          <motion.div
            className="profile-section"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <div className="profile-card">
              <div className="profile-card-left">
                <div className="profile-avatar-large">
                  {model.avatar
                    ? <img src={model.avatar} alt={model.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }} />
                    : <div className="avatar-initial">{model.name.charAt(0).toUpperCase()}</div>
                  }
                  <div className="avatar-online-dot" />
                </div>

                <div className="profile-attributes">
                  <div className="attr-row"><span className="attr-label">{t('name')}:</span><span className="attr-value">{model.name}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('gender')}:</span><span className="attr-value">{model.gender || t('Female')}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('age')}:</span><span className="attr-value">{model.age}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('interestedIn')}:</span><span className="attr-value">{model.interestedIn || 'Мужчины, Женщины, Пары'}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('pubicHair')}:</span><span className="attr-value">{model.pubicHair || 'Выбрито'}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('bust')}:</span><span className="attr-value">{model.bust}</span></div>
                  <div className="attr-row"><span className="attr-label">{t('butt')}:</span><span className="attr-value">{model.butt || 'Средняя'}</span></div>
                </div>
              </div>

              <div className="profile-card-right">
                <div className="attr-section-title">{t('interestsTitle')}:</div>
                <div className="interests-list">
                  {(model.interests || ['общение','танцы','мечты','дразнить','массаж','фут-фетиш']).slice(0,8).map((it) => (
                    <span className="interest-chip" key={it}>{it}</span>
                  ))}
                  <button className="show-more" onClick={() => openRegister(t('showMore'))}>{t('showMore')}</button>
                </div>

                {/* social networks removed from here and moved under chat input (see below) */}
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* RIGHT - CHAT */}
        <motion.div
          className="chat-section mobile-section"
          data-mobile="chat"
          initial={{ x: 40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          {/* Chat Header */}
          <div className="chat-header-block">
            <motion.div
              className="chat-model-name"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <span className="model-name-text">{model.name}</span>
              <span className="model-status">В ОБЩЕДОСТУПНОМ ЧАТЕ</span>
            </motion.div>
            <div className="chat-tab">
              <span>Чат</span>
            </div>
          </div>

          {/* Chat Messages */}
          <div className="chat-messages" ref={chatContainerRef}>
            <AnimatePresence initial={false}>
              {chatMessages.map((msg) => (
                <motion.div
                  key={msg.id}
                  className={`chat-msg ${msg.type === 'token' ? 'token-msg' : msg.type === 'subscribe' ? 'sub-msg' : 'text-msg'} ${msg.isOwn ? 'own-msg' : ''}`}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 12 }}
                  transition={{ type: 'spring', stiffness: 200, damping: 20, mass: 0.8 }}
                  layout
                >
                  {msg.type === 'token' ? (
                    <div className="token-content">
                      <span className="token-icon">🎁</span>
                      <div className="token-body">
                        <span className="msg-nick">{msg.nick}</span>
                        <span className="token-text">{msg.verb} <strong>{msg.amount}</strong> токенов!</span>
                        <span className="msg-time">{msg.time ? new Date(msg.time).toLocaleTimeString() : ''}</span>
                      </div>
                    </div>
                  ) : msg.type === 'subscribe' ? (
                    <div className="subscribe-content">
                      <span className="sub-icon">⭐</span>
                      <div className="sub-body">
                        <span className="msg-nick">{msg.nick}</span>
                        <span className="sub-text">подписался(ась) — добро пожаловать!</span>
                        <span className="msg-time">{msg.time ? new Date(msg.time).toLocaleTimeString() : ''}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="text-content">
                      <div className="text-row">
                        <span className="msg-nick">{msg.nick}</span>
                        <span className="msg-time">{msg.time ? new Date(msg.time).toLocaleTimeString() : ''}</span>
                      </div>
                      <div className="msg-text">{msg.content}</div>
                    </div>
                  )}
                </motion.div>
              ))}
            </AnimatePresence>
            <div ref={chatEndRef} />
          </div>

          {/* Chat Input */}
          <div className="chat-input-area">
            <form onSubmit={(e) => { e.preventDefault(); openRegister(t('modalChatMsg')); }} className="chat-form">
              <input
                type="text"
                className="chat-input"
                placeholder="Введите сообщение здесь..."
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onFocus={() => openRegister(t('modalChatMsg'))}
              />
              <motion.button
                type="button"
                className="chat-send-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => openRegister(t('modalChatMsg'))}
              >
                Отправить
              </motion.button>
            </form>
            <motion.button
              className={`private-msg-toggle ${isPrivateMode ? 'active' : ''}`}
              onClick={() => openRegister(t('modalPrivateMsg'))}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              Приватное Сообщение
            </motion.button>

            {/* Social networks moved below the private message button (was inside profile) */}
            <div className="social-networks-under-chat">
              <div className="attr-section-title">Соц. сети:</div>
              <a href="#" onClick={(e) => { e.preventDefault(); openRegister(t('modalSocialMsg')); }} className="social-link instagram">
                <svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="g2" x1="0" x2="1" y1="0" y2="1">
                      <stop offset="0" stopColor="#f58529" />
                      <stop offset="0.5" stopColor="#dd2a7b" />
                      <stop offset="1" stopColor="#8134af" />
                    </linearGradient>
                  </defs>
                  <rect rx="6" width="24" height="24" fill="url(#g2)" />
                  <path d="M12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6z" fill="#fff" opacity="0.95" />
                  <circle cx="17.5" cy="6.5" r="1.2" fill="#fff" opacity="0.95" />
                </svg>
                <span className="social-label">Instagram</span>
              </a>
              <a href="#" onClick={(e) => { e.preventDefault(); openRegister(t('modalSocialMsg')); }} className="social-link telegram">
                <svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect rx="6" width="24" height="24" fill="#E6F7FF" opacity="0" />
                  <path d="M21.2 3.9L2.9 10.2c-.6.2-.6.8-.1 1l4.2 1.3 1.6 5.2c.2.6.8.9 1.4.6l2.1-1.3 3.5 2.5c.6.4 1.4.1 1.6-.6l3.6-15c.2-.8-.6-1.5-1.4-1.2z" fill="#1DA1F2" />
                </svg>
                <span className="social-label">Telegram</span>
              </a>

              <a href="#" onClick={(e) => { e.preventDefault(); openRegister(t('modalSocialMsg')); }} className="social-link whatsapp">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="36" height="36" viewBox="0 0 48 48" aria-hidden="true">
                  <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path>
                  <path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path>
                  <path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path>
                  <path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path>
                  <path fill="#fff" fillRule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clipRule="evenodd"></path>
                </svg>
                <span className="social-label">WhatsApp</span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      {/* MOBILE BOTTOM TAB BAR */}
      <div className="mobile-tab-bar">
        <button
          className={`mobile-tab-btn ${mobileTab === 'video' ? 'active' : ''}`}
          onClick={() => setMobileTab('video')}
        >
          <span className="mtb-icon">📹</span>
          <span className="mtb-label">Трансляция</span>
        </button>
        <button
          className={`mobile-tab-btn ${mobileTab === 'chat' ? 'active' : ''}`}
          onClick={() => setMobileTab('chat')}
        >
          <span className="mtb-icon">💬</span>
          <span className="mtb-label">Чат</span>
        </button>
        <button
          className={`mobile-tab-btn ${mobileTab === 'profile' ? 'active' : ''}`}
          onClick={() => setMobileTab('profile')}
        >
          <span className="mtb-icon">👤</span>
          <span className="mtb-label">Профиль</span>
        </button>
      </div>

      {/* FOOTER */}
      <Footer />
    </motion.div>
  );
}

export default ModelPage;
